import { useTradesColumnStore } from '@/stores/trades/trades-column-store';
import { createCrossDndProvider, stripSidebarPrefix, addSidebarPrefix } from '@/components/shared/createCrossDndProvider';
import type { CreateCrossDndProviderConfig } from '@/components/shared/createCrossDndProvider';

// eslint-disable-next-line react-refresh/only-export-components -- re-exporting utility helpers alongside the Provider; splitting would require updating ~6 import sites
export { stripSidebarPrefix, addSidebarPrefix };

const { Provider, useCrossDnd } = createCrossDndProvider({
  useColumnStore: useTradesColumnStore as CreateCrossDndProviderConfig['useColumnStore'],
  tableScrollSelector: '[data-trades-table-scroll-container]',
  displayName: 'TradesCrossDndProvider',
});

export const TradesCrossDndProvider = Provider;
// eslint-disable-next-line react-refresh/only-export-components -- hook paired by design with the Provider above
export const useTradesCrossDnd = useCrossDnd;
